export default __webpack_public_path__ + "static/media/f9c5199e-a996-4c08-9042-1eb845bb7495.7d242f75.woff2";